import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class TenantConfigService {
  private config: any = {};

  constructor(private http: HttpClient, @Inject(DOCUMENT) private document: Document) {}

  loadConfig(tenant: string): Promise<void> {
    return this.http
      .get(`assets/_config/${tenant}.json`)
      .toPromise()
      .then((data: any) => {
        this.config = data;

        // Map old structure to maintain compatibility
        if (this.config.theme) {
          this.config.logoUrl = this.config.theme.logoUrl;
          this.config.iconUrl = this.config.theme.iconUrl;
          this.config.primaryColor = this.config.theme.primaryColor;
          // ... map other fields if needed
        }

        // Update head elements now that we have config
        this.updateHead();
      })
      .catch((error) => {
        console.error('Could not load tenant config', error);
        this.config = {};
      });
  }

  getConfig(): any {
    return this.config;
  }

  private updateHead(): void {
    const config = this.config;

    // Update title
    const titleElement = this.document.querySelector('app-title');
    if (titleElement) {
      titleElement.textContent = config.title || 'Default App Title';
    }

    // Update favicon
    let faviconElement = this.document.querySelector('#favicon') as HTMLLinkElement;
    if (!faviconElement) {
      faviconElement = this.document.createElement('link');
      faviconElement.id = 'favicon';
      faviconElement.rel = 'icon';
      faviconElement.type = 'image/x-icon';
      this.document.head.appendChild(faviconElement);
    }
    faviconElement.href = config.favicon || 'assets/favicon/favicon.ico';

    // Update meta description if available
    const metaDescription = this.document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', config.metaDescription || 'Default description');
    }
  }
}
